import * as React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function PageHeader() {
  return <section id="page-header" className="relative flex min-h-[45vh] flex-col items-center justify-center overflow-hidden bg-background py-20 lg:py-32">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/substation_outdoor_nameplates.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/substation_outdoor_nameplates.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/substation_outdoor_nameplates.png-wvc-sizes" alt="Substation nameplate labeling and high-voltage identification by Evermark Industrial Solutions" className="h-full w-full object-cover opacity-30" loading="lazy" decoding="async" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/95 to-secondary/95 mix-blend-multiply" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center md:text-left">
          
          {}
          <Breadcrumb className="mb-8 flex justify-center md:justify-start">
            <BreadcrumbList className="text-primary/80">
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/HomePage" className="text-primary/80 hover:text-primary transition-colors">
                    Home
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="text-primary/60">
                <ChevronRight className="size-4" />
              </BreadcrumbSeparator>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/IndustriesPage" className="text-primary/80 hover:text-primary transition-colors">
                    Industries
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="text-primary/60">
                <ChevronRight className="size-4" />
              </BreadcrumbSeparator>
              <BreadcrumbItem>
                <BreadcrumbPage className="font-medium text-primary">
                  Utilities & Power Generation
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>

          {}
          <span className="mb-4 block text-sm font-semibold uppercase tracking-wider text-primary font-default">
            For Utilities & Power Generation
          </span>

          {}
          <h1 className="mb-6 text-4xl font-bold leading-tight text-white sm:text-5xl lg:text-6xl font-default">
            Substation Nameplate Labeling, Switchgear & High-Voltage Identification
          </h1>

          {}
          <p className="mb-10 max-w-3xl text-lg text-foreground sm:text-xl font-default leading-relaxed mx-auto md:mx-0">
            Evermark Industrial Solutions produces the nameplates, equipment identification, and high-voltage warning signs that utilities and power-generation facilities need — engraved metal built to stay legible outdoors and in service for decades. Substation, switchgear, transformer, and plant identification, made to your utility's standard.
          </p>

          {}
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row md:justify-start">
            <Button asChild size="lg" className="w-full sm:w-auto">
              <Link to="/ContactPage">
                Request a Quote
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-primary text-primary hover:bg-primary hover:text-primary-foreground bg-transparent">
              
            </Button>
          </div>
          
        </div>
      </div>
    </section>;
}